import { render, staticRenderFns } from "./ArticleListIndex.vue?vue&type=template&id=1d8d2369&scoped=true&"
import script from "./ArticleListIndex.vue?vue&type=script&lang=js&"
export * from "./ArticleListIndex.vue?vue&type=script&lang=js&"
import style0 from "./ArticleListIndex.vue?vue&type=style&index=0&id=1d8d2369&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8d2369",
  null
  
)

export default component.exports